import clsx from "clsx";

import closeConversationIcon from "assets/icons/close-chat.svg";
import acceptConversationIcon from "assets/icons/accept-chat.svg";
import { ReactComponent as RefreshCircle } from "assets/icons/refresh-circle.svg";
import useTranslation from "hooks/useTranslation";

function ActionButton({ handler, type, disabled, text, classNames = {} }) {
  const { getTranslation } = useTranslation("CHAT");
  const { t } = getTranslation();

  // extract custom classNames
  const buttonClassName = classNames.button || "";
  const iconClassName = classNames.icon || "";

  const tickIcon = (
    <img
      alt="accept"
      src={acceptConversationIcon}
      className="header_mobile_menu_item"
    />
  );

  const crossIcon = (
    <img
      alt="close"
      src={closeConversationIcon}
      className="header_mobile_menu_item"
    />
  );

  const ICONS_PER_TYPE = {
    update: <RefreshCircle />,
    reject: crossIcon,
    close: crossIcon,
    transferToMe: tickIcon,
    accept: tickIcon,
  };

  const TEXTS_PER_TYPE = {
    update: t("UPDATE_CONV"),
    reject: t("REJECT_CONV"),
    close: t("CLOSE_CONV"),
    transferToMe: t("TRANSFER_TO_ME"),
    accept: t("ACCEPT_CONV"),
  };

  const labelText = text || TEXTS_PER_TYPE[type];
  const icon = ICONS_PER_TYPE[type];

  return (
    <div
      data-tool-tip-bottom-right={labelText}
      onClick={handler}
      className={clsx([
        "outline_grey_btn",
        disabled && "accept-btn-disabled",
        buttonClassName,
      ])}
    >
      <span className={clsx(["flex flex-ai-c flex-jc-c", iconClassName])}>
        {icon}
      </span>
      <span className="header_desktop_menu_item">{labelText}</span>
    </div>
  );
}

export default ActionButton;
